import { AuditTrail } from '@card-software/nexus-models';
import { Roll } from '@app/models/knitting/roll';

export interface ProductionCardBundleEvent {
  key: string;
  status: string;
  color: string;
  displayName: string;
}

export interface ProductionCardBundle extends AuditTrail {
  id: string;
  number: string;
  status: number;
  productionCardReference: string;
  expectedWeight: number;
  actualWeightInLbs?: number;
  rollNumbers: string[];
  rolls?: Roll[];
  assetId?: string;
}

export enum ProductionCardBundleStatus {
  Processing,
  ReadyForWeighing,
  Weighed,
  BRD,
  Used = 98,
  Removed = 99,
}
